import React, { useState } from 'react';
import { css, keyframes } from '@emotion/react';
import { Button, Tooltip } from 'antd';
import useIsClinician from 'vl-common/src/hooks/useIsClinician';

const pulse = keyframes`
  0% {
    filter: opacity(0);
  }
  50% {
    filter: opacity(50%);
    border: 4px solid var(--productPrimary);
  }
  100% {
    filter: opacity(0%);
  }
`;

const pulsateAnimationStyle = css`
  &::before {
    content: '';
    position: absolute;
    top: -3.5px;
    left: -3.5px;
    right: -3.5px;
    bottom: -3.5px;
    border-radius: 50%;
    animation-name: ${pulse};
    animation-duration: 2s;
    animation-iteration-count: 3;
    animation-fill-mode: forwards;
  }
`;

export const VideoMenuButton = ({
  title,
  disabled = false,
  onClick,
  icon,
  pulsateOnCallStart,
  'data-testid': dataTestid = ''
}: {
  title: string;
  disabled?: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  pulsateOnCallStart?: boolean;
  'data-testid': string;
}) => {
  const isClinician = useIsClinician();
  const [hasPulsatingEnded, setHasPulsatingEnded] = useState(isClinician || !pulsateOnCallStart);

  return (
    <Tooltip title={title} trigger={['hover', 'focus']}>
      <Button
        className="toggleButton"
        disabled={disabled}
        type="primary"
        shape="circle"
        onClick={onClick}
        icon={icon}
        aria-label={title}
        data-testid={dataTestid}
        onAnimationEnd={() => setHasPulsatingEnded(true)}
        css={css`
          ${!isClinician && pulsateOnCallStart && pulsateAnimationStyle}
          box-shadow: ${hasPulsatingEnded ? '0 3px 3px rgba(0, 0, 0, 0.5)' : 'none'};
          & > * {
            font-size: 20px;
            margin: 0 auto;
            display: block;
            padding: 0;
          }
        `}
      />
    </Tooltip>
  );
};

export default VideoMenuButton;
